<adapt-dialog [maxWidth]="600"
              [minHeight]="250"
              [fitHeight]="true">
    <h2 adapt-dialog-title>Assign integrated vision</h2>
    <div adapt-dialog-content
         class="d-flex flex-column h-100 gap-2">
        <ng-container *adaptLoading="!isInitialised">
            <span>Nominate one person to drive the integrated vision:</span>
            <adapt-select-person id="inputTeamLeader"
                                 [required]="true"
                                 [filter]="teamMembersOnly"
                                 [person]="assignedPerson"
                                 (personChange)="assignVisionTo($event)"></adapt-select-person>
            <span class="text-muted small">This can only be assigned to one of the team members</span>
        </ng-container>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveText="Assign"
                                   [saveIsDisabled]="entitiesAreUnmodifiedOrInvalid"
                                   [saveBlockingClick]="saveAndClose"
                                   [discardConfirmationInstance]="instance"> </adapt-standard-dialog-buttons>
</adapt-dialog>
